'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactScroll = require('react-scroll');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _AboutBanksInsurance = require('./AboutBanksInsurance.css');

var _AboutBanksInsurance2 = _interopRequireDefault(_AboutBanksInsurance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AboutBanksInsurance = (_dec = (0, _reactCssModules2.default)(_AboutBanksInsurance2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AboutBanksInsurance, _Component);

  function AboutBanksInsurance(props) {
    (0, _classCallCheck3.default)(this, AboutBanksInsurance);
    return (0, _possibleConstructorReturn3.default)(this, (AboutBanksInsurance.__proto__ || (0, _getPrototypeOf2.default)(AboutBanksInsurance)).call(this, props));
  }

  (0, _createClass3.default)(AboutBanksInsurance, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Fossil fuel finance & insurance';
      var url = _config2.default.domain + _config2.default.routes.about;

      var bannerImage = 'banks';
      var bannerHeadline = 'Fossil fuel finance & insurance';
      var bannerSubtitle = 'Banks and insurance companies support fossil fuel projects by financing and underwriting';

      var fossilFuelLendingCompanyTable = require('../../../static/images/fossil-fuel-lending-company-table.png');
      var fossilFuelInsuranceCompanyTable = require('../../../static/images/fossil-fuel-insurance-company-table.png');

      var bankIcon = require('../../../static/images/icn-ffb.svg');
      var insureIcon = require('../../../static/images/icn-ffi.svg');
      var riskyBusinessChartImg = require('../../../static/images/risky-business-chart-img.jpg');

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(title, bannerSubtitle, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-' + bannerImage },
            _react2.default.createElement(
              'h1',
              { styleName: 'image-banner-headline' },
              bannerHeadline
            )
          )
        ),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'lede' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Fossil Free Funds now incorporates banks and insurers into our fossil fuel ratings.'
              ),
              ' Financial companies are providing loans and underwriting that support fossil fuel projects \u2013 including tar sands, arctic drilling, and coal mining - but in order to keep global warming below 1.5\xB0C, the world needs to rapidly transition away from fossil fuels.'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 6 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'lede-section-wrap' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'lede-icon-hl' },
                      _react2.default.createElement('img', { src: bankIcon, alt: 'Banks', styleName: 'lede-icon' }),
                      'Banks'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Commercial and investment banks\' carbon-intensive funding is fundamentally incompatible with reaching the 1.5-degree aligned global goal necessary to prevent catastrophic climate harm.'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 6 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'lede-section-wrap b' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'lede-icon-hl' },
                      _react2.default.createElement('img', { src: insureIcon, alt: 'Insurers', styleName: 'lede-icon' }),
                      'Insurers'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Primary insurers and reinsurers are continuing to underwrite and invest in coal, oil, and gas, while experiencing dramatic losses associated with catastrophic weather-related events.'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'section' },
            _react2.default.createElement(
              'div',
              { styleName: 'search-bar-wrap' },
              _react2.default.createElement(
                'h3',
                null,
                'Get started looking up funds'
              ),
              _react2.default.createElement(_components.AutocompleteSearch, { destination: 'fossil-finance' }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.clean, title: 'Full list of funds', xstrong: true },
                  'Full list',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 12, md: 8 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'padding-right-row' },
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Risky business'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Since the Paris Agreement, the world\'s 60 largest banks have provided $6.9 trillion in financing to the fossil fuel industry, with $705 billion in fossil fuel financing in 2023 alone.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'By continuing to provide support to high carbon companies and projects, financial institutions are exacerbating the climate crisis, delaying the transition to a clean energy economy, and creating substantial portfolio risk for investors.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'Climate change creates financial risk.'
                    ),
                    ' Investors should be aware of which companies in their portfolios are contributing to those risks.'
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 12, md: 4 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'risky-business-chart-img-flex' },
                  _react2.default.createElement('img', {
                    src: riskyBusinessChartImg,
                    alt: 'Risky business',
                    styleName: 'risky-business-chart-img'
                  })
                )
              )
            )
          ),
          _react2.default.createElement('div', { styleName: 'a', id: 'methodology' }),
          _react2.default.createElement(
            'div',
            { styleName: 'section' },
            _react2.default.createElement(
              'div',
              { styleName: 'search-bar-wrap' },
              _react2.default.createElement(
                'h2',
                null,
                'Methodology'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The fossil fuel finance & insurance ratings use third-party expert data on bank lending and insurer policies from ',
                _react2.default.createElement(
                  'b',
                  null,
                  'Banking on Climate Chaos'
                ),
                ' and ',
                _react2.default.createElement(
                  'b',
                  null,
                  'Insure Our Future'
                ),
                '.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'scroll-button-flex' },
                _react2.default.createElement(
                  _reactScroll.Link,
                  {
                    to: 'methodology-fossil-fuel-finance',
                    spy: true,
                    smooth: true,
                    offset: 0,
                    duration: 500,
                    title: 'Fossil fuel finance'
                  },
                  _react2.default.createElement(
                    'button',
                    { styleName: 'scroll-button' },
                    'Fossil fuel finance',
                    _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
                  )
                ),
                _react2.default.createElement(
                  _reactScroll.Link,
                  {
                    to: 'methodology-fossil-fuel-insurance',
                    spy: true,
                    smooth: true,
                    offset: 0,
                    duration: 500,
                    title: 'Fossil fuel insurance'
                  },
                  _react2.default.createElement(
                    'button',
                    { styleName: 'scroll-button' },
                    'Fossil fuel insurance',
                    _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', { styleName: 'a', id: 'methodology-fossil-fuel-finance' }),
          _react2.default.createElement(
            'div',
            { styleName: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              'Fossil fuel finance'
            ),
            _react2.default.createElement(
              'p',
              null,
              'To rate mutual funds on fossil fuel finance, we use data from ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.bankingonclimatechaos.org/',
                  title: 'Banking on Climate Chaos',
                  xstrong: true
                },
                'Banking on Climate Chaos'
              ),
              '. Banking on Climate Chaos looks at 60 of the largest commercial and investment banks and tracks their total fossil fuel financing: lending, and underwriting debt and equity issuances. The data covers 2016 through 2023. The top bank, JPMorgan Chase, had over $430 billion in fossil fuel financing over this time period. For our fund ratings, we normalize the bank financing amounts from $USD to a 0-10 scale, where 10 is the worst score possible. These 0-10 figures represent a ',
              _react2.default.createElement(
                'b',
                null,
                'company fossil fuel finance risk score'
              ),
              '.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'finance-company-table-img-wrap' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.domain + '/images/fossil-fuel-lending-company-table.png',
                  title: 'Fossil fuel finance company table',
                  targetBlank: true
                },
                _react2.default.createElement('img', {
                  src: fossilFuelLendingCompanyTable,
                  alt: 'Fossil fuel finance company table',
                  styleName: 'finance-company-table-img'
                }),
                _react2.default.createElement(
                  'span',
                  { styleName: 'risky-business-chart-expand-label visible-xs' },
                  'Click to enlarge',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-expand' })
                )
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'If a fund invests in one of these banks, we flag the holding and display it on the fund profile.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We then use the normalized financing amounts (0-10 points) to calculate a ',
              _react2.default.createElement(
                'b',
                null,
                'fund fossil fuel finance risk score'
              ),
              '. For each flagged bank holding, the company risk score is multiplied by the holding weight (the percent of the fund\'s portfolio that holding accounts for). For example, if a flagged bank holding had a company risk score of 5, and made up 2% of the fund, 10 points would be assigned to the fund (5 x 2). These points are summed up and represent the fund fossil fuel finance risk score.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The last step is using the fund risk score to assign a ',
              _react2.default.createElement(
                'b',
                null,
                'fund fossil fuel finance grade'
              ),
              '. Funds are grouped into five tiers:'
            ),
            _react2.default.createElement(
              'table',
              { styleName: 'grade-tier-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Grade'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Risk score'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 1, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '0'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 2, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '0 - 5'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 3, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '5 - 15'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 4, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '15 - 25'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 5, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '25+'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'These tiers are determined using the distribution of results for funds in the research universe (open-end mutual funds and exchange-traded funds domiciled in the U.S. with at least 50% invested in equities).'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Funds with no exposure to the banks from the Banking on Climate Chaos report are assigned an A grade. For funds that do invest in these banks, the grade tiers roughly place 1/4 in the B tier, 1/4 in the C tier, etc.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In sum, the grades can be interepreted as saying: a fund with a lower grade has ',
              _react2.default.createElement(
                'b',
                null,
                'more exposure'
              ),
              ' to banks from the Banking on Climate Chaos report, or exposure to banks with a ',
              _react2.default.createElement(
                'b',
                null,
                'higher financing amount'
              ),
              ', than funds with a higher grade.'
            )
          ),
          _react2.default.createElement('div', { styleName: 'a', id: 'methodology-fossil-fuel-insurance' }),
          _react2.default.createElement(
            'div',
            { styleName: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              'Fossil fuel insurance'
            ),
            _react2.default.createElement(
              'p',
              null,
              'To rate mutual funds on fossil fuel insurance, we use data from the ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://docs.google.com/spreadsheets/d/157kNo3-xg7qeVHi8SF21VqjXKrSjHixL9UOKFTp8PKQ/edit#gid=769793980',
                  title: 'Insure Our Future Scorecard',
                  xstrong: true
                },
                'Insure Our Future Scorecard'
              ),
              '. Insure Our Future looks at 30 of the largest primary insurers and reinsurers and rates their fossil fuel insurance policies. For our fund ratings, we normalize the insurance policy ratings to a 0-10 scale, where 10 is the worst score possible. These 0-10 figures represent a ',
              _react2.default.createElement(
                'b',
                null,
                'company fossil fuel insurance risk score'
              ),
              '.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'finance-company-table-img-wrap' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.domain + '/images/fossil-fuel-insurance-company-table.png',
                  title: 'Fossil fuel insurance company table',
                  targetBlank: true
                },
                _react2.default.createElement('img', {
                  src: fossilFuelInsuranceCompanyTable,
                  alt: 'Fossil fuel insurance company table',
                  styleName: 'finance-company-table-img'
                }),
                _react2.default.createElement(
                  'span',
                  { styleName: 'risky-business-chart-expand-label visible-xs' },
                  'Click to enlarge',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-expand' })
                )
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'If a fund invests in one of these insurers, we flag the holding and display it on the fund profile.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We then use the normalized policy ratings (0-10 points) to calculate a ',
              _react2.default.createElement(
                'b',
                null,
                'fund fossil fuel insurance risk score'
              ),
              '. For each flagged insurance holding, the company risk score is multiplied by the holding weight (the percent of the fund\'s portfolio that holding accounts for). For example, if a flagged insurance holding had a company risk score of 5, and made up 2% of the fund, 10 points would be assigned to the fund (5 x 2). These points are summed up and represent the fund fossil fuel insurance risk score.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The last step is using the fund risk score to assign a ',
              _react2.default.createElement(
                'b',
                null,
                'fund fossil fuel insurance grade'
              ),
              '. Funds are grouped into five tiers:'
            ),
            _react2.default.createElement(
              'table',
              { styleName: 'grade-tier-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Grade'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Risk score'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 1, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '0'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 2, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '0 - 5'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 3, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '5 - 15'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 4, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '15 - 25'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_components.Grade, { grade: 5, blocksmall: true })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '25+'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'These tiers are determined using the distribution of results for funds in the research universe (open-end mutual funds and exchange-traded funds domiciled in the U.S. with at least 50% invested in equities).'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Funds with no exposure to the insurers from the Insure Our Future Scorecard are assigned an A grade. For funds that do invest in these insurers, the grade tiers roughly place 1/4 in the B tier, 1/4 in the C tier, etc.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In sum, the grades can be interpreted  as saying: a fund with a lower grade has ',
              _react2.default.createElement(
                'b',
                null,
                'more exposure'
              ),
              ' to insurers from the Insure Our Future Scorecard, or exposure to insurers with ',
              _react2.default.createElement(
                'b',
                null,
                'worse policy ratings'
              ),
              ', than funds with a higher grade.'
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return AboutBanksInsurance;
}(_react.Component)) || _class);
exports.default = AboutBanksInsurance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AboutBanksInsurance/AboutBanksInsurance.js
// module id = 1393
// module chunks = 0